import React, { useRef } from 'react';
import './PhoneInput.css';

const PhoneInput = ({ value, onChange, placeholder, required, name }) => {
  const inputRef = useRef(null);

  // Форматирование: +7 (XXX) XXX-XX-XX
  const formatPhone = (raw) => {
    // Оставляем только цифры
    let digits = raw.replace(/\D/g, '');

    // Если начинается с 8, заменяем на 7
    if (digits.startsWith('8') && digits.length > 1) {
      digits = '7' + digits.slice(1);
    }

    // Если пусто или только начало
    if (digits.length === 0) return '';

    // Ограничиваем 11 цифрами (7 + 10)
    digits = digits.slice(0, 11);

    // Форматируем
    let formatted = '+';

    if (digits.length >= 1) {
      formatted += digits[0]; // 7
    }
    if (digits.length >= 2) {
      formatted += ' (' + digits.slice(1, 4);
    }
    if (digits.length >= 5) {
      formatted += ') ' + digits.slice(4, 7);
    }
    if (digits.length >= 8) {
      formatted += '-' + digits.slice(7, 9);
    }
    if (digits.length >= 10) {
      formatted += '-' + digits.slice(9, 11);
    }

    return formatted;
  };

  const handleChange = (e) => {
    const rawValue = e.target.value;
    const formatted = formatPhone(rawValue);

    // Создаём синтетическое событие
    const syntheticEvent = {
      target: {
        name: name || 'phone',
        value: formatted,
      },
    };

    onChange(syntheticEvent);
  };

  const handleFocus = () => {
    // Если пусто, ставим начало
    if (!value) {
      const syntheticEvent = {
        target: {
          name: name || 'phone',
          value: '+7 (',
        },
      };
      onChange(syntheticEvent);
    }
  };

  const handleKeyDown = (e) => {
    // Разрешаем: Backspace, Delete, Tab, Escape, Enter, стрелки
    const allowed = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End',
    ];

    if (allowed.includes(e.key)) return;

    // Разрешаем Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
      return;
    }

    // Разрешаем + только в начале
    if (e.key === '+' && (!value || value.length === 0)) return;

    // Блокируем всё кроме цифр
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  // Проверяем полноту номера
  const digitsCount = (value || '').replace(/\D/g, '').length;
  const isComplete = digitsCount === 11;
  const isPartial = digitsCount > 0 && digitsCount < 11;

  return (
    <div className="phone-input-wrapper">
      <input
        ref={inputRef}
        type="tel"
        name={name || 'phone'}
        value={value || ''}
        onChange={handleChange}
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || '+7 (___) ___-__-__'}
        required={required}
        className={`phone-input ${isComplete ? 'phone-input--valid' : ''} ${isPartial ? 'phone-input--partial' : ''}`}
        autoComplete="tel"
        inputMode="tel"
      />
      {isComplete && <span className="phone-input__check">✓</span>}
    </div>
  );
};

export default PhoneInput;